import { render, staticRenderFns } from "./SchoolView.vue?vue&type=template&id=d7ea47f8&scoped=true&"
import script from "./SchoolView.vue?vue&type=script&lang=js&"
export * from "./SchoolView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolView.vue?vue&type=style&index=0&id=d7ea47f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ea47f8",
  null
  
)

component.options.__file = "SchoolView.vue"
export default component.exports